export const darkColors = {
  background_color: '#292929',
  text_color: '#ffffff',
}
